import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
    demoIndicatorWrapper: {
        display: 'flex',
        justifyContent: 'center',
        position: 'absolute',
        top: theme.spacing(1),
        right: 0,
        zIndex: 3,
        opacity: 1,
        width: theme.spacing(7),
        fontWeight: theme.typography.fontWeightBold,
        fontSize: theme.spacing(1.5),
        lineHeight: `${theme.spacing(2.3)}px`,
        backgroundColor: theme.palette.neutral[200],
        borderRadius: theme.dimensions.borderRadiusInput + ' 0 0 ' + theme.dimensions.borderRadiusInput,
        transition: 'transform 0.5s, opacity 0.5s',
    },
    demoIndicatorWrapperPub: {
        display: 'flex',
        justifyContent: 'center',
        position: 'absolute',
        top: theme.spacing(1),
        right: 0,
        zIndex: 3,
        opacity: 1,
        width: theme.spacing(7),
        fontWeight: theme.typography.fontWeightBold,
        fontSize: theme.spacing(1.5),
        lineHeight: `${theme.spacing(2.3)}px`,
        backgroundColor: theme.palette.neutral[200],
        borderRadius: theme.dimensions.borderRadiusInput + ' 0 0 ' + theme.dimensions.borderRadiusInput,
    },
    root: {
        height: '100%',
        borderRadius: theme.dimensions.borderRadiusPanel,
        color: 'red',
    },
    tooltip: {
        display: 'flex',
        flexWrap: 'nowrap',
        background: theme.palette.neutral[100],
        color: theme.palette.text.primary,
        borderRadius: theme.dimensions.borderRadiusInput,
        opacity: 1,
        padding: theme.spacing(0.5, 1),
        fontSize: theme.typography.size.s,

        '& .MuiTooltip-arrow': {
            '&:before': {
                background: theme.palette.neutral[100],
            },
        },
    },
    widget: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        backgroundColor: `${theme.palette.neutral[50]}`,
        borderRadius: theme.dimensions.borderRadiusPanel,
        cursor: 'grab',
        position: 'relative',
        boxShadow: '2px 2px 6px rgba(0, 0, 0, 0.45)',
        height: '100%',
        '&:hover': {
            '& $widgetButtons': {
                opacity: '1',
            },
            '& $demoIndicatorWrapper': {
                opacity: 0,
            },
            '& $demoIndicatorWrapperPub': {
                opacity: 1,
            },
        },
    },
    widgetButtons: {
        position: 'absolute',
        top: theme.spacing(1),
        right: theme.spacing(1),
        zIndex: 3,
        opacity: 0,
        transition: 'transform 0.5s, opacity 0.5s',

        '& svg': {
            color: theme.palette.secondary.main,
        },
    },
    widgetTitleWrapper: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
    },
    pb8: {
        paddingBottom: `${theme.spacing(1)} !important`,
    },
    widgetIcon: {
        color: theme.palette.secondary.main,
        paddingBottom: theme.spacing(2),

        '& svg': {
            height: '20px',
            width: '20px',
        },
    },
    widgetTitle: {
        paddingBottom: theme.spacing(2),
        textAlign: 'left',
        overflow: 'hidden',
        width: '88%',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        fontSize: theme.typography.size.xl,
        fontWeight: theme.typography.fontWeightRegular,
        color: theme.palette.text.primary,
    },
    widgetContent: {
        color: theme.palette.text.primary,
    },
}));
